import React, { useEffect, useRef, useState } from "react";
import "./CampaignPayments.css";
import { ReactComponent as BackButton } from "../../../../assests/back-arrow.svg";
import { ReactComponent as CollapseArrow } from "../../../../assests/CollapseArrow.svg";
import { ReactComponent as Delete } from "../../../../assests/delete_icon.svg";
import { ReactComponent as Warning } from "../../../../assests/emojione_warning.svg";
import EmptyViewCard from "../../../../components/common/empty-view-card/EmptyViewCard";
import IOSigning from "../io-signing/IOSigning";
import {
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  message,
  Radio,
  Row,
  Spin,
  Steps,
  Tooltip,
  Typography,
} from "../../../../components/common/utils/antd-imports/AntdImports";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  formatToMMDDYYYY,
  formatToUSCurrency,
} from "../../../../components/common/utils/Utils";
import {
  deleteTermsFromCheckOut,
  getCampaignsForPurchase,
  updateTermsToCampaigns,
} from "../../../../store/thunks/buyer-thunks/BuyerThunks";
import { getDefaultPaymentTerms } from "../../../../store/thunks/common-thunks/commonThunk";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { useMediaQuery } from "react-responsive";
import DeleteCamapign from "../../../../components/modal/delete-campaign/DeleteCampaign";
import CustomTermsModal from "../../../../components/modal/checkout-page-modal/CustomTermsModal";
const { Text } = Typography;
const CampaignPayment = (userRole) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [expandedCards, setExpandedCards] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const steps = [{ title: "Review & Customize" }, { title: "IO Signing" }];
  const stepRef = useRef(currentStep);
  const [campaignDetails, setCampaignDetails] = useState(null);
  const [deleteCampaignModal, setDeleteCampaignModal] = useState(false);
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const [selectedRadio, setSelectedRadio] = useState("default");
  const [customTermsValues, setCustomTermsValues] = useState({});
  const [netTermsData, setNetTermsData] = useState([]);
  const [showCard, setShowCard] = useState(false);

  const [remainingAmount, setRemainingAmount] = useState();
  const isSmall = useMediaQuery({ minWidth: 0, maxWidth: 375 });
  const [modalType, setModalType] = useState(null);
  const [termsRequest, setTermsRequest] = useState(false);
  const PDF_BASE_URL = "/pdf";
  const numberedSteps = steps?.map((step, index) => ({
    ...step,
  }));
  const {
    purchaseCampaign,
    isLoading: campaignPurchaseLoader,
    totalPriceDetails,
    termsDetails,
  } = useSelector((state) => state?.campaignpurchase);
  const { isLoading: termsCampaignLoader } = useSelector(
    (state) => state.termsCampaign,
  );
  const { isPaymentLoading } = useSelector((state) => state?.campaignpurchase);
  const { isDeleting } = useSelector((state) => state?.buyerCampaigns);
  const isLoading =
    campaignPurchaseLoader ||
    termsCampaignLoader ||
    isPaymentLoading ||
    isDeleting;
  const defaultTerms = termsDetails?.default_terms_total || {};
  const termsPercentage = termsDetails?.default_terms_percentage || {};
  const termsApprovalFlags = termsDetails?.terms_auto_approve_flags || {};
  const [buttonText, setButtonText] = useState("Proceed with Default Terms");
  const [isTotalMatched, setIsTotalMatched] = useState(false);
  const isDeleteDisabled = totalPriceDetails?.CustomTermsStatus === 0;
  const isWithdrawnTerms = totalPriceDetails?.WithdrawTermStatus === 1;
  const isCustomTermsApplied = totalPriceDetails?.CustomTermsApplied;
  const radioDefaultTerms = totalPriceDetails?.DefaultTermsStatus === 1;
  const radioCustomTerms = totalPriceDetails?.CustomTermsStatus === 1;
  const shouldDisableInput =
    selectedRadio === "default" ||
    totalPriceDetails?.CustomTermsApplied > 0 ||
    (totalPriceDetails?.TermsApplied &&
      Object.keys(totalPriceDetails?.TermsApplied).length > 0);
  const containerRef = useRef(null);
  const [form] = Form.useForm();
  useEffect(() => {
    if (currentStep === 1 && containerRef.current) {
      containerRef.current.scrollTo = 0;
    }
  }, [currentStep]);
  useEffect(() => {
    const savedStep = parseInt(localStorage.getItem("currentStep"));
    if (!isNaN(savedStep)) {
      setCurrentStep(savedStep);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("currentStep", currentStep?.toString());
  }, [currentStep]);
  const everyCampaignWithStatusTwo =
    purchaseCampaign?.every(
      (campaign) => campaign?.payment_terms_status === 2,
    ) || false;
  const hasWaiting = purchaseCampaign?.some((campaign) =>
    campaign?.booking_array?.some(
      (product) => product?.product_terms_approval === 0,
    ),
  );
  const hasApproved = purchaseCampaign?.some((campaign) =>
    campaign?.booking_array?.some(
      (product) => product?.product_terms_approval === 1,
    ),
  );
  const hasRejected = purchaseCampaign?.some((campaign) =>
    campaign?.booking_array?.some(
      (product) => product?.product_terms_approval === 2,
    ),
  );
  const isCustomTermsWithdrawn =
    purchaseCampaign?.length > 0
      ? purchaseCampaign?.some(
          (campaign) => campaign?.payment_terms_status == 3,
        )
      : false;
  const allWaitingProducts = hasWaiting && !hasApproved && !hasRejected;
  const allApprovedProducts = hasApproved && !hasWaiting && !hasRejected;
  const allRejectedProducts = hasRejected && !hasWaiting && !hasApproved;
  const waitingAndApproved = hasWaiting && hasApproved && !hasRejected;
  const waitingAndRejected = hasWaiting && hasRejected && !hasApproved;
  const approvedAndRejected = hasApproved && hasRejected && !hasWaiting;
  const mixedStatusProducts = hasWaiting && hasApproved && hasRejected;
  const hasCampaignWithStatusTwo =
    purchaseCampaign?.some(
      (campaign) => campaign?.payment_terms_status === 2,
    ) || false;
  const shouldDisable =
    (((radioDefaultTerms &&
      radioCustomTerms &&
      selectedRadio === "custom" &&
      !isTotalMatched) ||
      (!radioDefaultTerms && radioCustomTerms && isCustomTermsApplied == 0) ||
      (!radioDefaultTerms && !radioCustomTerms && isCustomTermsApplied < 1) ||
      (!radioDefaultTerms &&
        !radioCustomTerms &&
        isCustomTermsApplied > 0 &&
        isWithdrawnTerms == 1 &&
        !everyCampaignWithStatusTwo)) &&
      !(
        !radioDefaultTerms &&
        radioCustomTerms &&
        isCustomTermsApplied > 0 &&
        isWithdrawnTerms == 1 &&
        everyCampaignWithStatusTwo
      )) ||
    (!radioDefaultTerms && radioCustomTerms && hasWaiting) ||
    (!radioDefaultTerms && radioCustomTerms && hasRejected) ||
    purchaseCampaign?.length <= 0;
  useEffect(() => {
    if (purchaseCampaign?.length > 0) {
      const firstId = purchaseCampaign[0]?.id;
      if (firstId) {
        setExpandedCards({ [firstId]: true });
      }
    }
  }, [purchaseCampaign, termsDetails]);

  const toggleCard = (id) => {
    setExpandedCards((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleGetCampaignsForPurchase = () => {
    if (isLoggedIn && purchaseCampaign) {
      dispatch(getCampaignsForPurchase());
      dispatch(getDefaultPaymentTerms()); // getting the payment terms values
    }
  };
  useEffect(() => {
    handleGetCampaignsForPurchase();
  }, []);
  const handleStepChange = (value) => {
    if (value <= currentStep) {
      setCurrentStep(value);
    } else {
      message.warning(
        `Please click the '${buttonText}' to continue to the next step.`,
      );
    }
  };
  const formatLabel = (key) => {
    //formatting the every label into redable like net_30_percent to Net 30
    if (key === "stripe_percent") return "Upfront";
    if (key.startsWith("net_") && key.endsWith("_percent")) {
      const day = key.split("_")[1];
      return `Net ${day}`;
    }
    return key;
  };
  const handleDeleteProduct = (campaign) => {
    if (isCustomTermsApplied > 0 && !(campaign?.product_terms_approval === 2)) {
      return;
    }
    setCampaignDetails(campaign);
    setDeleteCampaignModal(true);
  };
  const goToSecurePayment = () => {
    if (currentStep < numberedSteps?.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };
  useEffect(() => {
    if (radioDefaultTerms === undefined || radioCustomTerms === undefined) {
      return;
    }
    const allApprovedProducts =
      purchaseCampaign?.length > 0 &&
      purchaseCampaign?.every((campaign) =>
        campaign?.booking_array?.every(
          (product) => product?.product_terms_approval === 1,
        ),
      );
    if (radioDefaultTerms && radioCustomTerms) {
      setButtonText(
        selectedRadio === "default"
          ? "Proceed with Default Terms"
          : "Request Custom Terms",
      );
    } else if (radioDefaultTerms && !radioCustomTerms) {
      setSelectedRadio("default");
      setButtonText("Proceed with Default Terms");
    } else if (!radioDefaultTerms && radioCustomTerms) {
      setSelectedRadio("custom");
      if (
        isCustomTermsApplied > 0 &&
        isWithdrawnTerms &&
        everyCampaignWithStatusTwo
      ) {
        setButtonText("Proceed with Custom Terms");
      } else if (isCustomTermsApplied > 0 && isWithdrawnTerms && hasWaiting) {
        setButtonText("Waiting for Approval");
      } else if (isCustomTermsApplied > 0 && hasApproved) {
        setButtonText("Proceed with Custom Terms");
      } else {
        setButtonText("Request Custom Terms");
      }
    } else if (totalPriceDetails && !radioDefaultTerms && !radioCustomTerms) {
      setSelectedRadio("custom");
      if (
        isCustomTermsApplied >= 1 &&
        !radioDefaultTerms &&
        !radioCustomTerms &&
        allApprovedProducts
      ) {
        setButtonText("Proceed with Custom Terms");
      } else if (
        !radioDefaultTerms &&
        !radioCustomTerms &&
        isCustomTermsApplied >= 1
      ) {
        setButtonText("Waiting for Approval");
      }
    }
  }, [
    radioDefaultTerms,
    radioCustomTerms,
    isCustomTermsApplied,
    isWithdrawnTerms,
    everyCampaignWithStatusTwo,
    selectedRadio,
    purchaseCampaign,
    totalPriceDetails,
    hasWaiting,
  ]);
  useEffect(() => {
    const getNetTermDates = (termsObj, stripeFeeObj) => {
      const today = new Date();
      return Object.entries(termsObj || {})
        ?.filter(
          ([key]) => key?.startsWith("net_") && key?.endsWith("_percent"),
        )
        ?.map(([key, value]) => {
          const days = parseInt(key?.match(/\d+/)[0], 10);
          const futureDate = new Date(today);
          futureDate.setDate(futureDate.getDate() + days);

          return {
            label: `Net ${days}`,
            date: futureDate.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            }),
            value: parseFloat(value?.toFixed(2)),
            stripeFee: isFinite(stripeFeeObj?.[key])
              ? parseFloat(Number(stripeFeeObj[key])?.toFixed(2))
              : 0,
          };
        })
        ?.filter((item) => item?.value > 0);
    };

    if (totalPriceDetails) {
      let data;
      if (totalPriceDetails?.CustomTermsApplied <= 0) {
        // Default terms
        data = getNetTermDates(
          termsDetails?.default_terms_total,
          totalPriceDetails?.TermsStrpeFee,
        );
      } else {
        // Custom terms
        data = getNetTermDates(
          totalPriceDetails?.TermsApplied,
          totalPriceDetails?.TermsStrpeFee,
        );
      }
      setNetTermsData(data);
      const allValuesZeroExceptStripe = Object.entries(
        totalPriceDetails?.TermsStrpeFee || {},
      )?.every(([key, value]) => {
        if (key === "stripe_percent") return true; // ignore stripe_percent
        return Number(value) === 0;
      });

      if (
        allValuesZeroExceptStripe &&
        totalPriceDetails?.CustomTermsApplied > 0
      ) {
        setShowCard(false);
      } else if (
        allValuesZeroExceptStripe &&
        totalPriceDetails?.CustomTermsApplied <= 0
      ) {
        setShowCard(false);
      } else {
        setShowCard(true);
      }
    }
  }, [
    termsDetails,
    totalPriceDetails?.TermsApplied,
    totalPriceDetails?.TermsStrpeFee,
    totalPriceDetails?.CustomTermsApplied,
    totalPriceDetails,
  ]);

  const requestCustomTerms = () => {
    const today = new Date();
    const payload = {
      percentage_data: [],
      term_type: [],
      calendar_data: [],
    };

    Object?.entries(customTermsValues)?.forEach(([termKey, value]) => {
      if (value && parseFloat(value) > 0) {
        payload?.percentage_data?.push(parseFloat(value));
        payload?.term_type?.push(termKey);
        let dueDate = new Date(today);
        if (termKey?.startsWith("net_") && termKey?.endsWith("_percent")) {
          const day = parseInt(termKey.split("_")[1], 10);
          dueDate.setDate(today.getDate() + day);
        }
        const formattedDate = dueDate
          ?.toLocaleDateString("en-GB")
          ?.replace(/\//g, "-");
        payload?.calendar_data?.push(formattedDate);
      }
    });

    dispatch(updateTermsToCampaigns(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        message.success(res?.payload?.message || "Terms applied successfully.");
        setTimeout(() => {
          dispatch(getCampaignsForPurchase());
        }, 500);
      } else if (res?.payload?.status == 0) {
        message.error(res?.payload?.message || "Failed to apply terms.");
      }
    });
    return payload;
  };
  useEffect(() => {
    if (totalPriceDetails?.TermsApplied) {
      setCustomTermsValues(totalPriceDetails?.TermsApplied);
    } else {
      setCustomTermsValues({});
    }
  }, [totalPriceDetails]);
  const handleRemoveTerms = () => {
    dispatch(deleteTermsFromCheckOut()).then((res) => {
      if (res?.payload?.status == 1) {
        message.success(
          res?.payload?.message || "Terms withdrawn successfully.",
          5,
        );
        setTermsRequest(false);
      } else {
        message.error(res?.payload?.message || "Something went wrong.");
      }
      dispatch(getCampaignsForPurchase()).then((action) => {
        const res = action.payload;
        if (res?.status == 0) {
          window.location.reload();
        }
      });
    });
  };

  return (
    <>
      <div className="campaign-payments-main-components">
        <div>
          <Row
            className={`${
              currentStep === 1 ? "step-padding-depend-step-class" : ""
            } complete-campaign-text-row `}
          >
            <Col>
              <BackButton
                onClick={(e) => {
                  if (currentStep === 0) {
                    navigate("/buyer/viewcart");
                  } else {
                    stepRef.current = Math.max(stepRef.current - 1, 0);
                    setCurrentStep(stepRef.current);
                  }
                }}
                className=" back-arrow-payment-main back-navigation-arrow"
              />
            </Col>
            <Col>
              <Text className="complete-campaign-text">
                Complete Your Campaign Purchase
              </Text>
            </Col>
          </Row>

          <div className="scrollable-content">
            <Row
              className="review-secure-row"
              justify={"center"}
              gutter={[16, 16]}
            >
              <Steps
                type="navigation"
                current={currentStep}
                initial={0}
                onChange={handleStepChange}
                items={numberedSteps}
                disabled={false}
                direction={isSmall ? "vertical" : "horizontal"}
                responsive={false}
                className="review-steps-custom"
              />
            </Row>
          </div>
        </div>
        <div className="order-summary-first-step-main-container">
          {currentStep === 0 && (
            <>
              <Row style={{ margin: "20px" }}>
                {purchaseCampaign?.length > 0 ? (
                  <Card className="card-summary-card card-summary-mobile">
                    <div className="order-summary-scroll-main-container-mobile">
                      <Row className="order-payment-total-row">
                        <Text className="order-summary-heading">
                          Order Summary
                        </Text>
                        <Text className="order-summary-heading-amount">
                          Total:{"\u00A0"}
                          {formatToUSCurrency(
                            totalPriceDetails?.TotalPrice || 0,
                          )}
                        </Text>
                      </Row>
                      {purchaseCampaign?.map((campaign, index) => (
                        <div key={campaign?.id ?? index}>
                          <Row
                            style={{
                              marginInlineStart: "24px",
                              marginTop: "10px",
                            }}
                          >
                            <Text className="payments-campaign-id">
                              {" "}
                              {campaign?.cid}
                            </Text>
                          </Row>
                          <Row
                            className="urban-billboard-row"
                            onClick={() => toggleCard(campaign?.id)}
                          >
                            <Col
                              style={{
                                maxWidth: "80%",
                                marginLeft: "3px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <CollapseArrow
                                className={`collapse-arrow-mark ${
                                  expandedCards[campaign?.id] ? "open" : ""
                                }`}
                              />
                              <Text
                                className="urban-billboard-blitz-text"
                                onClick={() =>
                                  navigate(
                                    `/buyer/campaigndetails?_id=${btoa(
                                      campaign?.id,
                                    )}`,
                                  )
                                }
                              >
                                {campaign?.name}
                              </Text>
                            </Col>
                          </Row>
                          {expandedCards[campaign?.id] && (
                            <Row className="campaigns-upfront-products-mobile-row">
                              <Col className="products-purchase-dates-mobile">
                                <span className="products-purchase-dates-mobile">
                                  {formatToMMDDYYYY(
                                    campaign?.campaign_dates
                                      ?.campaign_start_date,
                                  )}
                                </span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="11"
                                  viewBox="0 0 23 16"
                                  fill="none"
                                >
                                  <path
                                    d="M22.7071 8.7071C23.0976 8.31658 23.0976 7.68342 22.7071 7.29289L16.3431 0.928931C15.9526 0.538406 15.3195 0.538406 14.9289 0.928931C14.5384 1.31946 14.5384 1.95262 14.9289 2.34314L20.5858 8L14.9289 13.6569C14.5384 14.0474 14.5384 14.6805 14.9289 15.0711C15.3195 15.4616 15.9526 15.4616 16.3431 15.0711L22.7071 8.7071ZM0 9H22V7H0V9Z"
                                    fill="#D2042D"
                                  />
                                </svg>
                                <span className="products-purchase-dates-mobile">
                                  {formatToMMDDYYYY(
                                    campaign?.campaign_dates?.campaign_end_date,
                                  )}
                                </span>
                              </Col>
                              <Col>
                                <span className="product-count-collapse">
                                  {`${
                                    campaign?.booking_array?.length || 0
                                  } Products`}
                                </span>
                              </Col>
                            </Row>
                          )}
                          {expandedCards[campaign?.id] && (
                            <Card className="urban-billboard-sub-card-mobile">
                              <Row
                                className="campaigns-upfront-products-row"
                                gutter={[16, 16]}
                              >
                                <Col>
                                  <Text className="products-text-non">
                                    Products
                                  </Text>
                                </Col>
                              </Row>
                              {campaign?.booking_array?.map(
                                (products, productIndex) => (
                                  <div key={productIndex}>
                                    <Row
                                      className="time-square-row"
                                      gutter={[16, 16]}
                                    >
                                      <Col
                                        className="products-title-col"
                                        sm={6}
                                      >
                                        <Tooltip
                                          styles={{
                                            body: { color: "#fff" },
                                          }}
                                          title={
                                            <pre className="tooltip-product-card">
                                              {products?.title} {"\u00A0"}
                                              {campaign?.cid}
                                            </pre>
                                          }
                                        >
                                          <Text
                                            className="time-square-digital-col-text truncate-title-text"
                                            style={{
                                              display: "inline-block",
                                              maxWidth: "100%",
                                            }}
                                          >
                                            {products?.title}
                                          </Text>
                                        </Tooltip>
                                        <Delete
                                          className={
                                            isCustomTermsApplied > 0 &&
                                            !(
                                              products?.product_terms_approval ===
                                              2
                                            )
                                              ? "disabled-opacity"
                                              : ""
                                          }
                                          style={{
                                            width: "16px",
                                            height: "16px",
                                            cursor: "pointer",
                                            color: "#000",
                                            marginLeft: "10px",
                                          }}
                                          onClick={() =>
                                            handleDeleteProduct(products)
                                          }
                                        />
                                      </Col>

                                      <Col className="products-delete-col">
                                        {totalPriceDetails?.CustomTermsApplied >
                                          0 && (
                                          <>
                                            {products?.product_terms_approval ===
                                              0 && (
                                              <span className="waiting-for-approval-text">
                                                Waiting for approval
                                              </span>
                                            )}

                                            {products?.product_terms_approval ===
                                              1 && (
                                              <span className="waiting-for-approval-text approved-text-color ">
                                                Approved
                                              </span>
                                            )}

                                            {products?.product_terms_approval ===
                                              2 && (
                                              <span className="waiting-for-approval-text rejected-text-color ">
                                                Rejected
                                              </span>
                                            )}
                                          </>
                                        )}
                                      </Col>
                                      <Col>
                                        <Text className="time-square-digital-price">
                                          {formatToUSCurrency(
                                            products?.offerpriceperselectedDates ||
                                              0,
                                          )}
                                        </Text>
                                      </Col>
                                    </Row>
                                  </div>
                                ),
                              )}
                              <Divider className="campaign-diver-mobile" />

                              <Row
                                gutter={[16, 16]}
                                className="total-campaign-row"
                              >
                                <Col className="products-title-col-value-mobile">
                                  <Text className="total-campaign-amount-label-text">
                                    Total Campaign Cost
                                  </Text>
                                </Col>
                                <Col className="total-campaign-total-price-col-mobile">
                                  <Text className="total-campaign-total-price-text">
                                    {formatToUSCurrency(
                                      campaign?.totalamount || 0,
                                    )}
                                  </Text>
                                </Col>
                              </Row>
                            </Card>
                          )}
                        </div>
                      ))}
                    </div>
                  </Card>
                ) : (
                  <div>
                    <EmptyViewCard
                      header="Campaigns added..."
                      text="It looks like you haven't purchased any campaigns"
                    />
                  </div>
                )}
              </Row>
              <Row style={{ margin: "20px" }}>
                <Radio.Group
                  style={{ width: "100%" }}
                  value={selectedRadio}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (isDeleteDisabled) return;
                    setSelectedRadio(value);

                    if (value === "default") {
                      setCustomTermsValues({});
                      setRemainingAmount(
                        termsDetails?.default_terms_final_total || 0,
                      );
                      setIsTotalMatched(false);
                    }
                  }}
                  className={`custom-radio-group ${
                    isDeleteDisabled ? "disable-opacity" : ""
                  }`}
                >
                  <Card className="default-terms-radio-btn-card ">
                    <Row className="default-terms-card-row">
                      <Col className="default-terms-radio-mobile">
                        <Radio
                          size="large"
                          value="default"
                          className={`
    ${selectedRadio === "default" ? "radio-active" : "radio-inactive"} 
    ${!radioDefaultTerms && isCustomTermsApplied > 0 ? "disable-pointer" : ""}
  `}
                        />
                      </Col>
                      <Col
                        className={`total-campaign-total-price-text-default ${
                          selectedRadio === "default"
                            ? "radio-active"
                            : "radio-inactive"
                        }`}
                      >
                        Default Terms
                      </Col>
                    </Row>
                    {Object.entries(defaultTerms)?.map(([terms, amount]) => (
                      <Row className="default-terms-card-net-value">
                        <Col className="default-terms-net-mobile">
                          <Text className="default-terms-mobile-label">
                            {formatLabel(terms)} (
                            {termsPercentage?.[terms]?.toFixed(2) ?? "0.00"}%)
                          </Text>
                        </Col>
                        <Col>
                          <Text className="default-terms-mobile-label">
                            {formatToUSCurrency(amount || 0)}
                          </Text>
                        </Col>
                      </Row>
                    ))}
                    <Divider className="default-terms-divider" />
                    <Row className="default-terms-card-total-row">
                      <Col>
                        <Text className="default-terms-grand-total">Total</Text>
                      </Col>
                      <Col>
                        <Text className="default-terms-grand-total">
                          {formatToUSCurrency(
                            termsDetails?.default_terms_final_total || 0,
                          )}
                        </Text>
                      </Col>
                    </Row>
                  </Card>
                  <Card className="custom-terms-mobile-card ">
                    <Row className="default-terms-card-row">
                      <Col className="default-terms-radio-mobile">
                        <Radio
                          size="large"
                          value="custom"
                          className={
                            selectedRadio === "custom"
                              ? "radio-active"
                              : "radio-inactive"
                          }
                        />
                      </Col>
                      <Col
                        className={`total-campaign-total-price-text ${
                          selectedRadio === "custom"
                            ? "radio-active"
                            : "radio-inactive"
                        }`}
                      >
                        Custom Terms
                      </Col>
                      {isCustomTermsWithdrawn && (
                        <Badge
                          count="Terms Withdrawn"
                          className="terms-withdrawn-badge"
                          align="right"
                        />
                      )}
                    </Row>

                    {Object.entries(defaultTerms)?.map(([terms, amount]) => (
                      <Row className="custom-terms-card-net-value">
                        <Col className="custom-terms-net-mobile">
                          <Text className="default-terms-mobile-label">
                            {formatLabel(terms)} (
                            {termsPercentage?.[terms]?.toFixed(2) ?? "0.00"}%)
                          </Text>
                        </Col>

                        <Col className="custom-terms-values-mobile">
                          {termsApprovalFlags?.[terms] === 0 ? (
                            <Warning className="seller-approval-warning-icon-mobile" />
                          ) : (
                            <div className="warning-placeholder" />
                          )}

                          <Input
                            className={`enter-amount-custom-input ${
                              selectedRadio === "default"
                                ? "disabled-opacity"
                                : ""
                            }`}
                            type="number"
                            inputMode="decimal"
                            pattern={undefined}
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e?.key)) {
                                e.preventDefault();
                              }
                            }}
                            value={customTermsValues?.[terms]}
                            min={0}
                            disabled={shouldDisableInput}
                            addonBefore={
                              <span className="dollar-icon-enter-amount">
                                $
                              </span>
                            }
                            placeholder="Amount"
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              let inputVal = e.target.value;
                              const numVal = parseFloat(inputVal) || 0;
                              setCustomTermsValues((prev = {}) => {
                                const customTotalExcludingCurrent =
                                  Object?.entries(prev)
                                    ?.filter(([key]) => key !== terms)
                                    ?.reduce(
                                      (sum, [, val]) =>
                                        sum + (parseFloat(val) || 0),
                                      0,
                                    );
                                const expectedTotal = parseFloat(
                                  termsDetails?.default_terms_final_total || 0,
                                );
                                const proposedTotal =
                                  customTotalExcludingCurrent + numVal;
                                const isExceeding =
                                  Number(proposedTotal.toFixed(2)) >
                                  Number(expectedTotal.toFixed(2));
                                if (isExceeding) {
                                  message.warning(
                                    "Total custom terms cannot exceed seller terms total.",
                                  );
                                  return prev;
                                }
                                const updated = { ...prev, [terms]: inputVal };
                                setIsTotalMatched(
                                  Number(proposedTotal.toFixed(2)) ===
                                    Number(expectedTotal.toFixed(2)),
                                );
                                setRemainingAmount(
                                  Math.max(expectedTotal - proposedTotal, 0),
                                );
                                return updated;
                              });
                            }}
                          />
                        </Col>
                      </Row>
                    ))}
                    <Divider className="default-terms-divider" />
                    <Row className="default-terms-card-total-row">
                      <Col>
                        <Text className="default-terms-grand-total">Total</Text>
                      </Col>
                      <Col>
                        <Text className="default-terms-grand-total">
                          {formatToUSCurrency(
                            remainingAmount !== undefined
                              ? remainingAmount
                              : termsDetails?.default_terms_final_total || 0,
                          )}
                        </Text>
                      </Col>
                    </Row>
                    <Row className="default-terms-amount-warning-row">
                      <Col className="default-terms-ampunt-warning-icon">
                        <ExclamationCircleOutlined style={{ width: "16px" }} />
                      </Col>
                      <Col className="default-terms-amount-warning-text">
                        <Text className="your-terms-amount-warning-text">
                          Your custom terms must total{" "}
                          <span>
                            {formatToUSCurrency(
                              termsDetails?.default_terms_final_total || 0,
                            )}
                          </span>{" "}
                          to match the campaign cost
                        </Text>
                      </Col>
                    </Row>
                  </Card>
                </Radio.Group>
              </Row>
              <Card className="warning-terms-message-card">
                <Row className="seller-approval-warning-mobile">
                  <Col style={{ width: "5%", alignItems: "center" }}>
                    <Warning className="seller-approval-warning-icon" />
                  </Col>

                  <Col style={{ width: "90%" }}>
                    <Text className="cancel-campaign-text">
                      This term requires seller approval. We’ll notify you once
                      the seller responds
                    </Text>
                  </Col>
                </Row>
              </Card>
              <Card className="products-held-card">
                <Row className="product-held-row">
                  <Text className="product-held-text">Note</Text>
                  <Text className="product-held-brief-text">
                    Products aren't held while waiting. If someone else buys
                    them, they're gone. Be quick to secure your spot!
                  </Text>
                </Row>
              </Card>
              <Card className="cancellation-card">
                <Row className="product-held-row">
                  <Text className="product-held-text">Did you Know?</Text>
                  <Text className="cancel-campaign-text">
                    You can cancel your campaign any time before it starts.
                    Refunds are processed automatically minus Stripe fees.
                  </Text>
                </Row>
              </Card>
              <Card className="cancellation-card">
                <Row className="product-held-row">
                  <Text className="product-held-text">Cancellation Policy</Text>

                  <Text className="product-held-brief-text">
                    Want to know how cancellations and refunds work?
                  </Text>
                  <a
                    href={`${PDF_BASE_URL}/AMPUserAgreement.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Text className="cancellation-refund-link">
                      Cancellation & Refund Policy
                    </Text>
                  </a>
                </Row>
              </Card>
            </>
          )}
          {currentStep === 1 && (
            <>
              <IOSigning
                selectedRadio={selectedRadio}
                isCustomTermsApplied={isCustomTermsApplied}
              />
            </>
          )}
        </div>
      </div>
      <div className="secure-payment-card">
        <Row>
          {currentStep === 0 && (
            <>
              {isWithdrawnTerms ? (
                <div className="request-still-wating-container ">
                  <Text
                    className="request-still-wating-text"
                    onClick={() => {
                      setModalType("withdraw");
                      setTermsRequest(true);
                    }}
                  >
                    Withdraw the Request
                  </Text>

                  <Button
                    type="primary"
                    className={`proceed-to-payment-btn request-still-wating-btn ${
                      shouldDisable ? "disabled-opacity" : ""
                    }`}
                    onClick={() => {
                      if (shouldDisable) {
                        return;
                      }
                      if (
                        selectedRadio === "default" ||
                        (!radioDefaultTerms &&
                          !radioCustomTerms &&
                          (isCustomTermsApplied >= 1 ||
                            (isCustomTermsApplied > 2 &&
                              hasCampaignWithStatusTwo)))
                      ) {
                        goToSecurePayment();
                      } else if (
                        (!radioDefaultTerms &&
                          radioCustomTerms &&
                          isCustomTermsApplied > 0 &&
                          isWithdrawnTerms &&
                          everyCampaignWithStatusTwo &&
                          allApprovedProducts) ||
                        (!radioDefaultTerms &&
                          radioCustomTerms &&
                          isCustomTermsApplied > 0 &&
                          hasApproved)
                      ) {
                        goToSecurePayment();
                      } else if (selectedRadio === "custom") {
                        requestCustomTerms();
                      }
                    }}
                  >
                    <Text className="proceed-to-secure-payment">
                      {buttonText}
                    </Text>
                  </Button>
                </div>
              ) : (
                <>
                  <Button
                    type="primary"
                    className={`proceed-to-payment-btn  ${
                      (radioDefaultTerms &&
                        radioCustomTerms &&
                        selectedRadio === "custom" &&
                        !isTotalMatched) ||
                      (!radioDefaultTerms &&
                        radioCustomTerms &&
                        isCustomTermsApplied == 0) ||
                      (!radioDefaultTerms &&
                        !radioCustomTerms &&
                        isCustomTermsApplied < 1) ||
                      (!radioDefaultTerms &&
                        !radioCustomTerms &&
                        isCustomTermsApplied > 0 &&
                        isWithdrawnTerms == 1 &&
                        !everyCampaignWithStatusTwo &&
                        !(
                          !radioDefaultTerms &&
                          radioCustomTerms &&
                          isCustomTermsApplied > 0 &&
                          isWithdrawnTerms == 1 &&
                          everyCampaignWithStatusTwo
                        )) ||
                      (!radioDefaultTerms && radioCustomTerms && hasWaiting) ||
                      (!radioDefaultTerms && radioCustomTerms && hasRejected) ||
                      purchaseCampaign?.length <= 0
                        ? "disabled-opacity"
                        : ""
                    }`}
                    onClick={() => {
                      if (
                        selectedRadio === "default" ||
                        (!radioDefaultTerms &&
                          !radioCustomTerms &&
                          isCustomTermsApplied >= 1)
                      ) {
                        goToSecurePayment();
                      } else if (selectedRadio === "custom") {
                        requestCustomTerms();
                      }
                    }}
                  >
                    <Text className="proceed-to-secure-payment">
                      {buttonText}
                    </Text>
                  </Button>
                </>
              )}
            </>
          )}
        </Row>
      </div>
      <DeleteCamapign
        setDeleteCampaignModal={setDeleteCampaignModal}
        deleteCampaignModal={deleteCampaignModal}
        type="deleteProduct"
        selectedCampaignPage={false}
        campaignPurchase={true}
        deleteCampaignId={campaignDetails?.campaign_id}
        productId={campaignDetails?.id}
        price={campaignDetails?.price}
      />
      <CustomTermsModal
        termsRequest={termsRequest}
        setTermsRequest={setTermsRequest}
        modalType={modalType}
        handleRemoveTerms={handleRemoveTerms}
        allWaitingProducts={allWaitingProducts}
        allApprovedProducts={allApprovedProducts}
        allRejectedProducts={allRejectedProducts}
        waitingAndApproved={waitingAndApproved}
        waitingAndRejected={waitingAndRejected}
        approvedAndRejected={approvedAndRejected}
        mixedStatusProducts={mixedStatusProducts}
      />
      {isLoading && <Spin size="large" fullscreen />}
    </>
  );
};
export default CampaignPayment;
